import React from "react";

interface LogoProps {
  fill?: string;
}

export const Logo: React.FC<LogoProps> = ({ fill = "white" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 40 32"
      width="40"
      height="32"
    >
      <path
        fill={fill}
        d="M28.223 16.406c3.312-1.145 5.682-3.786 5.682-7.708 0-.982-.497-3.367-2.303-4.906-1.19-1.014-2.911-2.214-8.466-2.348-1.149-.028-4.641.097-4.641.097v.2c.986.754 2.047 2.002 2.557 3.442.53-.018 1.334-.061 2.127-.018 2.231.119 3.203.536 4.208 1.326 1.011.794 1.555 2.157 1.548 3.394-.006 1.688-.807 3.432-3.244 4.425-1.971.804-4.355.981-4.355.981l-.002.615s1.427.683 2.854 2.57c1.229 1.624 8.364 12.126 8.364 12.126h5.894s-9.525-13.269-10.223-14.196ZM9.37 26.55h-3.3V5.141c.046 0 1.481-.019 2.375-.019 3.685 0 5.728 1.906 5.785 4.521.036 1.588-.435 3.111-2.055 4.232-1.322.916-3.163 1.189-3.163 1.189v.69s2.553.38 3.849.986c2.414 1.127 3.131 2.878 3.148 5.143.027 3.58-3.43 4.667-6.639 4.667ZM1.554 1.532v29.07h6.451c8.468 0 12.945-3.12 12.945-9.025 0-3.516-2.208-5.842-5.683-6.649 2.264-1.339 3.719-3.309 3.719-6.244 0-3.138-1.863-7.286-9.665-7.286-3.284 0-6.883.106-7.767.134Z"
      />
    </svg>
  );
};
